module.exports = __webpack_public_path__ + "img/Visual analysis.2c46bd03.svg";